import { Box, Button, Text, Title } from "@mantine/core";
import { modals } from "@mantine/modals";
import i18n from "i18next";
import { store } from "../../store";
import { authChange } from "../../store/auth";
import { rememberReturnPath } from "../../utils/session-return-path";
import classes from "./SessionExpiredDialog.module.css";

const MODAL_ID = "session-expired";
let open = false;
// False until app.tsx has finished its boot /me check: a stale token found at
// boot must clear the session (login page), not open this dialog over a
// dashboard that would then fire requests with the dead token.
let bootChecked = false;

export function markBootChecked(): void {
  bootChecked = true;
}

export function isBootChecked(): boolean {
  return bootChecked;
}

function SessionExpiredDialog() {
  const t = (key: string) => i18n.t(key, { ns: "layout" });

  const handleSignIn = () => {
    rememberReturnPath();
    // Session-ийг цэвэрлэхэд ConditionalAccess (app.tsx) /login руу шилжүүлнэ.
    store.dispatch(authChange());
    modals.close(MODAL_ID);
    open = false;
  };

  return (
    <Box className={classes.dialog}>
      <Title order={2} className={classes.title}>
        {t("sessionExpired.title")}
      </Title>
      <Text className={classes.text}>{t("sessionExpired.text")}</Text>
      <Box className={classes.footer}>
        <Button color="brand" radius="md" onClick={handleSignIn}>
          {t("sessionExpired.action")}
        </Button>
      </Box>
    </Box>
  );
}

/** /2fa/auth 401: нэвтэрсэн хэрэглэгчид нэг л «Сесс дууслаа» цонх үзүүлнэ. */
export function showSessionExpired(): void {
  if (open) return;
  open = true;
  modals.open({
    modalId: MODAL_ID,
    centered: true,
    withCloseButton: false,
    closeOnClickOutside: false,
    closeOnEscape: false,
    trapFocus: true,
    radius: 16,
    padding: 0,
    size: "sm",
    children: <SessionExpiredDialog />,
  });
}
